import initialState from 'reducers/initialStates/messages';
import { messageEventTypes } from 'events/messages';

export default function messagesReducer(state = initialState, action) {
  switch (action.type) {
    case messageEventTypes.CLEAR_MESSAGES:
      return handleClearMessages(state);

    case messageEventTypes.CLEAR_PENDING_ATTACHMENTS:
      return handleClearPendingAttachments(state);

    case messageEventTypes.CLEAR_PENDING_MESSAGES:
      return handleClearPendingMessages(state);

    case messageEventTypes.MESSAGE_CREATE_PENDING:
      return handleCreatePendingMessage(state, action);

    case messageEventTypes.MESSAGE_CREATE_PENDING_ATTACHMENTS:
      return handleCreatePendingAttachments(state, action);

    case messageEventTypes.MESSAGE_CREATE_UPDATE_SENDING:
      return handleSendingMessage(state, action);

    case messageEventTypes.MESSAGE_CREATE_UPDATE_SUCCESS:
      return handleSendingMessageSuccess(state, action);

    case messageEventTypes.MESSAGE_CREATE_UPDATE_FAILURE:
      return handleSendingMessageError(state, action);

    case messageEventTypes.UPDATE_CURRENT_PAYMENT_ASSETS:
      return handleUpdateCurrentPaymentAssets(state, action);

    default:
      return state;
  }
}

function handleClearMessages(state) {
  return { ...state, data: {} };
}

function handleClearPendingMessages(state) {
  return { ...state, pending: [] };
}

function handleClearPendingAttachments(state) {
  return { ...state, attachments: [] };
}

function handleCreatePendingMessage(state, action) {
  return { ...state, pending: [...state.pending, action.payload] };
}

function handleCreatePendingAttachments(state, action) {
  return { ...state, attachments: [...state.attachments, ...action.payload] };
}

function handleSendingMessage(state, action) {
  const messageAttrs = {
    ...state.data[action.payload.id],
    ...action.payload,
    _isSending: true,
    _hasErrors: false,
    _errors: [],
  };

  return { ...state, data: { ...state.data, [action.payload.id]: messageAttrs } };
}

function handleSendingMessageSuccess(state, action) {
  const { payload } = action;

  return {
    ...state,
    data: { ...state.data, [payload.id]: { ...state.data[payload.id], ...payload, _isSending: false } },
  };
}

function handleSendingMessageError(state, action) {
  const { id } = action.payload;

  return {
    ...state,
    data: {
      ...state.data,
      [id]: { ...state.data[id], _isSending: false, _hasError: true, _errors: action.errors },
    },
  };
}

function handleUpdateCurrentPaymentAssets(state, action) {
  const { currency, monetaryUnit, paymentId, memo } = action.payload;

  return {
    ...state,
    paymentAssets: {
      currency: currency,
      memo: memo,
      monetaryUnit: monetaryUnit,
      paymentId: paymentId,
    },
  };
}
